<script setup>
  import { stringify } from 'qs'

  const { t, locale } = useI18n()
  const { generateSeoMeta } = useSeo()

  const useBreadcrumbs = useBreadcrumbsStore()
  const pagesStore = usePagesStore()

  const { data: page, pending: pageLoading } = await useAsyncData(
    `page-world-forum-mediation-${locale.value}`,
    async () => {
      await pagesStore.fetchOneBySlug(
        t('slugs.worldForumMediation'),
        locale.value,
        stringify({
          populate: {
            banner: true,
            seo: {
              populate: ['shareImage']
            },
            tab1: true,
            tab2: true,
            tab3: true
          }
        })
      )
      return pagesStore.item
    },
    {
      watch: [locale]
    }
  )

  const groupedTabContent = computed(() => {
    if (!page.value?.tab1) return []

    const data = page.value.tab1.filter((item) => item.__component !== 'shared.tab-title')
    const grouped = []
    let ctaGroup = []

    for (const item of data) {
      if (item.__component === 'shared.cta') {
        ctaGroup.push(item)
      } else {
        if (ctaGroup.length > 0) {
          grouped.push({ type: 'cta', items: ctaGroup })
          ctaGroup = []
        }
        grouped.push({ type: 'other', item })
      }
    }

    if (ctaGroup.length > 0) {
      grouped.push({ type: 'cta', items: ctaGroup })
    }

    return grouped
  })

  watchEffect(() => {
    if (page.value) {
      useBreadcrumbs.set([
        {
          name: t('menu.mainMenu.network'),
          path: 'commissions'
        },
        {
          name: page.value?.title || t('menu.sectionNetwork.worldForumMediation'),
          path: 'pages-uia-world-forum-of-mediation-centres'
        }
      ])
    }
  })

  useHead(() =>
    generateSeoMeta({
      title: page.value?.seo?.metaTitle || page.value?.title || t('menu.sectionNetwork.worldForumMediation'),
      description: page.value?.seo?.metaDescription,
      image: page.value?.seo?.shareImage || page.value?.banner,
      schemaType: 'WebPage',
      basePath: '/network/uia-world-forum-of-mediation-centres'
    })
  )
</script>

<template>
  <div>
    <CommonLoading v-if="pageLoading" />
    <template v-else>
      <CommonBanner v-if="page && page.banner" :title="page.title" :banner="page.banner" class="hidden lg:block" />
      <div class="container my-4 lg:mt-0 lg:mb-8">
        <div class="lg:-mt-24">
          <LayoutArticle v-if="page && page.title">
            <template #content>
              <div v-if="pageLoading">{{ t('components.common.loading') }}</div>
              <div v-else>
                <template v-for="(group, index) in groupedTabContent" :key="index">
                  <CommonCta v-if="group.type === 'cta'" :ctas="group.items" class="not-prose" />
                  <CommonStrapiBlockRenderer v-else :item="group.item" />
                </template>
              </div>
            </template>
          </LayoutArticle>
        </div>
      </div>
    </template>
  </div>
</template>
